/** @format */
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { CreditRange, CustomCourseUnitAttainment, DPSMBase, Module, OtmId, Urn } from 'common-typescript/types';
import { ModuleStateObject } from 'sis-components';
import { StudentPlanUiActionsServiceImplementation } from '../../../common/service/student-plan-ui-actions-service-implementation.service';
import { PlanStructureData } from '../../plan-data.service';
import { getParents, getStudyLevel, getTargetCredits } from './module-helpers';

@Component({
    selector: 'app-plan-structure-module-summary',
    standalone: false,
    templateUrl: './plan-structure-module-summary.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class PlanStructureModuleSummaryComponent implements OnInit, OnChanges {
    // Fudis has heading levels 1-6 and in this component we need headingLevel + 1
    @Input({ required: true }) headingLevel: 1 | 2 | 3 | 4 | 5;
    @Input({ required: true }) module: Module;
    @Input({ required: true }) planStructureData: PlanStructureData;

    moduleStateObject: ModuleStateObject;
    targetCredits: CreditRange;
    studyLevel: Urn;
    parents: DPSMBase[] = [];

    constructor(private readonly studentPlanUIActionsImplementationService: StudentPlanUiActionsServiceImplementation) {}

    ngOnInit() {
        this.syncDerivedState();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['module'] || changes['planStructureData']) {
            this.syncDerivedState();
        }
    }

    private syncDerivedState() {
        if (!this.module || !this.planStructureData?.planStateAndData?.planStateObject) {
            return;
        }
        this.moduleStateObject = this.planStructureData.planStateAndData.planStateObject.modules[this.module.id];
        this.targetCredits = getTargetCredits(this.module);
        this.studyLevel = getStudyLevel(this.module);
        this.parents = getParents(this.module, this.planStructureData.validatablePlan);
    }

    getCustomCourseUnitAttainment(id: OtmId): CustomCourseUnitAttainment {
        return this.planStructureData.planStateAndData.planData.attainmentsById[id] as CustomCourseUnitAttainment;
    }

    getAttainedCreditsText(creditsText: string) {
        const attainedCredits = this.moduleStateObject?.moduleValidationResult?.attainedCredits;
        return attainedCredits ? `${attainedCredits} ${creditsText}` : '-';
    }

    openModuleInfo(parent: DPSMBase): void {
        const data: PlanStructureData = this.planStructureData;
        this.studentPlanUIActionsImplementationService.openModuleInfoModalHandler(
            parent,
            data.validatablePlan,
            data.matchingStudyRight,
            data.planValidationResult,
        );
    }
}
